import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import bannerImage from 'images/detailed-trial-results-banner.jpg';
import ProductSidebar from 'components/ProductSidebar';
import PDFBox from 'components/PDFBox';
import { fetchOneTrialResult } from 'store/getOneTrialResultSlice';
import { fetchTrialResults } from 'store/getTrialResultsSlice';

const DetailedTrialResults = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { title, trials } = useSelector(state => state?.oneTrialResult?.data?.data) || {};
    const { crops } =
        useSelector(state => state?.trialResults?.data?.data) || {};
    const otherCrops = crops?.filter(el => el.title !== title)

    useEffect(() => {
        const slug = location.pathname.split('/').pop();
        dispatch(fetchOneTrialResult({ slug }));
        dispatch(fetchTrialResults({}));
    }, [dispatch, location.pathname]);

    return (
        <>
            <Banner title={title} image={bannerImage} buttonText="View results" />
            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={<ProductSidebar title="Trial results for other crops" data={otherCrops} />}
                >
                    <PDFBox data={trials} />
                </WithSidebar>
            </section>
        </>
    );
};

export default DetailedTrialResults;
